// extracted by mini-css-extract-plugin
export default {"App":"App_App__zyLpp","Body":"App_Body__PMojS","Login":"App_Login__yuWzh","Version":"App_Version__yIMrr"};